import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  IHeartbeatSetting,
  IHeartbeatSettingRow,
} from '../../../../view/settings/api-automation-settings/heartbeat-settings/heartbeat-settings.model';

@Injectable({
  providedIn: 'root',
})
export class HeartbeatSettingService {
  private readonly HEARTBEAT_SETTINGS_URL = `${this.baseUrl}/api-automation/heartbeat-settings`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<IHeartbeatSetting>> {
    return this.http.get<GetManyResponseInterface<IHeartbeatSetting>>(this.HEARTBEAT_SETTINGS_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<IHeartbeatSetting>> {
    return this.http.get<BaseOneResponseInterface<IHeartbeatSetting>>(`${this.HEARTBEAT_SETTINGS_URL}/${recordId}`, {
      params,
    });
  }

  public addOne(record: IHeartbeatSettingRow): Observable<BaseOneResponseInterface<IHeartbeatSetting>> {
    return this.http.post<BaseOneResponseInterface<IHeartbeatSetting>>(this.HEARTBEAT_SETTINGS_URL, record);
  }

  public editOne(
    recordId: number,
    record: IHeartbeatSettingRow,
  ): Observable<BaseOneResponseInterface<IHeartbeatSetting>> {
    return this.http.patch<BaseOneResponseInterface<IHeartbeatSetting>>(
      `${this.HEARTBEAT_SETTINGS_URL}/${recordId}`,
      record,
    );
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          heartbeatSettings: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(`${this.HEARTBEAT_SETTINGS_URL}/bulk/delete`, httpOptions);
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.HEARTBEAT_SETTINGS_URL}/${recordIds[0]}`);
  }
}
